import { useMemo } from 'react'
import { useGetWaSessions } from '../whatsapp/useGetWaSessions'
import { useGetCompanyBillingConfig } from '../company/useGetCompanyBillingConfig'

export const useAccess = () => {
  const { data: configs } = useGetCompanyBillingConfig()

  const allowedUsersCount = useMemo(() => {
    return (
      configs?.billingConfigs.reduce((acc, el) => acc + el.numberOfUser, 0) || 0
    )
  }, [configs?.billingConfigs])
  const allowedWaSessionsCount = useMemo(() => {
    return (
      configs?.billingConfigs.reduce(
        (acc, el) => acc + el.numberOfWaSession,
        0,
      ) || 0
    )
  }, [configs?.billingConfigs])

  const hideAddUser = useMemo(() => {
    const safeTotal = configs?.activeUser || 0
    if (safeTotal >= allowedUsersCount) {
      return true
    }
    return false
  }, [allowedUsersCount, configs?.activeUser])
  const { data: waSessions } = useGetWaSessions({})
  const hideAddWa = useMemo(() => {
    if ((waSessions?.length || 0) >= allowedWaSessionsCount) {
      return true
    }
    return false
  }, [allowedWaSessionsCount, waSessions?.length])
  return {
    hideAddUser,
    hideAddWa,
    loyaltyEnabled: configs?.loyaltyEnabled,
    allowAccess: configs?.allowAccess,
    attendanceEnabled: configs?.attendanceEnabled,
    vouchersEnabled: configs?.vouchersEnabled,
    serviceMaterialEnabled: configs?.serviceMaterialEnabled,
    leaveEnabled: configs?.leaveEnabled,
  }
}
